import { Component, OnInit, Input } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { FarmService } from "../farm.service";
import { FarmDTOGeneric } from "src/app/shared/dtos/FarmDTOGeneric";

@Component({
  selector: "app-particular-farm",
  templateUrl: "./particular-farm.component.html",
  styleUrls: ["./particular-farm.component.css"]
})
export class ParticularFarmComponent implements OnInit {

  farm: FarmDTOGeneric;

  constructor(
    private route: ActivatedRoute,
    private farmService: FarmService
  ) { }

  ngOnInit() {
   const id = +this.route.snapshot.paramMap.get('id');

    this.farmService.getFarmById(id)
      .subscribe(
        farm => this.farm = farm);
  }

  public getUrlImage(url: string) {
    return this.farmService.getUrlImage(url);
  }
}
